import Phaser from "phaser";

export class GazeCursor {
  private graphic: Phaser.GameObjects.Arc;

  constructor(scene: Phaser.Scene) {
    this.graphic = scene.add.circle(0, 0, 6, 0xffffff, 0.5);
    this.graphic.setDepth(100);
  }

  update(x: number, y: number): void {
    this.graphic.setPosition(x, y);
  }

  destroy(): void {
    this.graphic.destroy();
  }
}
